import type { IconData } from '@stacksjs/iconify-core'

export const stampF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 7.465a4 4 0 1 1 4 0V14H8zM2 15h16a2 2 0 0 1 2 2v2H0v-2a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default stampF
